import React, { useEffect, useState, useContext } from 'react';
import { Col, Container, Table, Button } from 'reactstrap'
import styled from 'styled-components'
import api from "../../services/api"
import { toast } from 'react-toastify'
import { AuthContext } from '../../contexts/AuthContext'
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import utils from '../../helpers/utils'
import paymentStatusEnum from '../../helpers/enums/paymentStatus'
import paymentTypeEnum from '../../helpers/enums/paymentType'
import PaymentDataModal from './PaymentDataModal'
import FullPaymentModal from './FullPaymentModal'
import decimal from '../../helpers/decimal'
// import swal from "sweetalert";

// const CancelButton = styled.div`
//     background-color: #F8642C;
//     color: #fff;
//     border-radius: 5px;
//     font-weight: bold;
//     text-align: center;
//     padding: 5px 10px;
//     cursor: pointer;
// `;

const filterPaymentsFromDB = payment => {
  return {
    id: payment._id,
    course: payment.course,
    value: payment.value,
    status: payment.status,
    createdAt: payment.timestamps.createdAt,
    type: payment.type,
    cc: payment.creditCard,
    recurrent: payment.recurrent,
    installments: payment.installments
  } 
}

function Profile(props) {
  const { dispatch, auth } = useContext(AuthContext);
  const [password, setPassword] = useState("")
  const [passwordConfirmation, setPasswordConfirmation] = useState("")
  const [errors, setErrors] = useState({})
  const [paymentData, setPaymentData] = useState([])

  const [paymentModal, setPaymentModal] = useState(false)
  const [fullPaymentModal, setFullPaymentModal] = useState(false)
  const [paymentToEdit, setPaymentToEdit] = useState([])

  const [reloadData, setReloadData] = useState(false)
  
  dayjs.extend(utc);

  useEffect(async () => {
    await getData()
  }, [reloadData])

  const getData = () => {
    api.get(`/userPayments`).then(res => {
      if (res.payments)
        setPaymentData(res.payments.map(filterPaymentsFromDB))
    })
  }

  const getStatus = (status) => {
    switch (status) {
      case paymentStatusEnum.PENDING: return 'Pendente'
      case paymentStatusEnum.SUCCESS: return 'Pago'
      case paymentStatusEnum.ACTIVE: return 'Ativo'
      case paymentStatusEnum.REJECTED: return 'Rejeitado'
      case paymentStatusEnum.FINISHED: return 'Recorrência paga'
      case paymentStatusEnum.CANCELLED: return 'Cancelado'
      case paymentStatusEnum.RETRY_LIMIT: return 'Excesso de tentativas'
      case paymentStatusEnum.CC_EXPIRED: return 'Cartão expirado'
      case paymentStatusEnum.NEGOTIATED: return 'Negociado'
    }
  }

  const getType = (type) => {
    switch (type) {
      case paymentTypeEnum.CREDIT_CARD: return 'Cartão de Crédito'
      case paymentTypeEnum.RECURRENT: return 'Recorrência'
      case paymentTypeEnum.RECURRENT_PAID: return 'Parcela'
      case paymentTypeEnum.BILLET: return 'Boleto'
    }
  }

  const onSubmit = (e) => {
    let isValid = true;
    let error = {}
    if (!password) {
      error.password = "O campo senha é obrigatório"
      isValid = false;
    } else if (password.length < 6) {
      error.password = "A senha não contém no mínimo 6 caracteres"
      isValid = false;
    } else if (password !== passwordConfirmation) {
      error.password = "As senhas não são iguais"
      isValid = false
    }
    if (!passwordConfirmation) {
      error.passwordConfirmation = "O campo confirmação de senha é obrigatório"
      isValid = false
    } else if (passwordConfirmation !== password) {
      error.passwordConfirmation = "As senhas não são iguais"
      isValid = false
    }
    setErrors(error)
    if (isValid) {
      const data = {
        userId: auth.user._id,
        newPassword: password,
        newPasswordConfirmation: passwordConfirmation
      }
      api.put(`/student/reset-password`, data).then(res => {
        if (res.success) {
          toast.success("Perfil editado com sucesso!");
          props.history.goBack()
        } else {
          if (Array.isArray(res.error)) {
            let error = ''
            res.error.forEach(e => {
              error += `O campo ${e.path[0]} está com valores inválidos.\n`
            })
            setErrors({ serverSide: error })
            toast.error("Ops, algo deu errado!");
          } else {
            setErrors({ serverSide: res.error })
            toast.error("Ops, algo deu errado!");
          }
        }
      }).catch((err) => {
        toast.error("Ops, algo deu errado!");
        console.log(err)
      })
    }
  }
  
  const handlePaymentModal = () => {
    setPaymentModal(false)
    setPaymentToEdit([])
    setErrors({})
  }

  const handleFullPaymentModal = () => {
    setFullPaymentModal(false)
    setPaymentToEdit([])
    setErrors({})
    setReloadData(true)
  }

  const handleValue = payment => {
    if(payment.type === 3) {
      if(payment.installments) {
        const remainingValue = decimal.mul(payment.value, payment.installments)
        return payment.installments + " X " + utils.formatBRL(decimal.div(remainingValue, payment.installments))
      }
      else return "N/A"
    }
    else return utils.formatBRL(payment.value)
  }

  const checkDisabledPayment = payment => {
    if(payment.status === 5) return true // Pagamento cancelado
    else if(payment.status === 6) return true // Recorrência cancelado por excesso de tentativas 
    else if(payment.status === 7) return true // Recorrência cancelado por cartão de crédito expirado 
    else return false
  }

  return (
    <>
      <PaymentDataModal visible={paymentModal} handleModal={handlePaymentModal} payment={paymentToEdit} />
      <FullPaymentModal visible={fullPaymentModal} handleModal={handleFullPaymentModal} payment={paymentToEdit} />
      <Container>
        <Col xs={12}>
          <div style={{ display: 'flex', flexDirection: "column", alignItems: "center", padding: 50 }}>
            <h1>Meu perfil</h1>
            <div className="col-xs-12 col-md-4 mb-3">
              <input
                type="password"
                value={password}
                error={errors ? errors.password : ''}
                onChange={event => setPassword(event.target.value)}
                className="form-control"
                placeholder="Nova senha"
              />
            </div>
            <div className="col-xs-12 col-md-4 mb-3">
              <input
                type="password"
                placeholder="A senha deve conter no mínimo 6 caracteres"
                value={passwordConfirmation}
                error={errors ? errors.passwordConfirmation : ''}
                onChange={event => setPasswordConfirmation(event.target.value)}
                className="form-control"
                placeholder="Confirmar senha"
              />
            </div>
            <div className="col-xs-12 col-md-4 mb-3">
              <button
                className="large-btn"
                onClick={event => onSubmit(event)}
              >
                Salvar
              </button>
            </div>
          </div>
        </Col>
        <Col xs={12}>
          <Table>
            <thead>
              <tr>
                <th>Curso</th>
                <th>Valor</th>
                <th>Status</th>
                <th>Tipo</th>
                <th>Data do pagamento</th>
                <th>Dados de pagamento</th>
                {/* <th>&nbsp;</th> */}
              </tr>
            </thead>
            <tbody>
              {paymentData.map(payment => {
                return <tr key={payment._id}>
                  <th scope="row">{payment.course.name}</th>
                  <td>{handleValue(payment)}</td>
                  <td>{getStatus(payment.status)}</td>
                  <td>{getType(payment.type)}</td>
                  <td>{dayjs(payment.createdAt).format("DD/MM/YYYY")}</td>
                  {payment.status === 3 && (
                    <td>
                      <Button
                        style={{ backgroundColor: "rgba(41,107,169,1)", border: 'none' }}
                        onClick={() => {
                          setPaymentModal(true)
                          setPaymentToEdit(payment)
                        }}
                      >
                        Alterar dados
                      </Button>
                    </td>
                  )}

                  {checkDisabledPayment(payment) && (
                    <td>
                      <Button
                        style={{ backgroundColor: "rgba(41,107,169,1)", border: 'none' }}
                        onClick={() => {
                          setFullPaymentModal(true)
                          setPaymentToEdit(payment)
                        }}
                      >
                        Efetuar pagamento restante
                      </Button>
                    </td>
                  )}
                  {/* <td><CancelButton onClick={() => cancelPayment(payment.id)}>Cancelar</CancelButton></td> */}
                </tr>
              })}
            </tbody>
          </Table>
        </Col>
      </Container>
    </>
  );
}

export default Profile;